module.exports = __webpack_public_path__ + "a0a405fd9fbc1b64bbc9d0ab373d11dc.MP3";